import $ from 'jquery';
import DataDevis from './dataDevis'

const adminUsers = ['admin','manager']

class ApiConnector {

    constructor(url,application,front) {
        this.application = application
        this.url = url+'/service.php'
        this.type = ''
        this.id = ''
        this.directFrontUrl = front
        this.axaLogout = true
        this.axaAlive = false
        this.axaVehicules = false
        this.axaFirstAlive = 0
        this.axaLastAlive = 0
        this.axaNLogin = 0
        this.axaNWorkers = 1
        this.backend = url
        this.lastConnectedStatus = false
        this.lastOperator = false
        this.onAfterLogin = []
        this.onAfterLogout = []
        this.onConnectedStatus = []
        this.devisViews = []
        this.clockViews = []
        this.enableViews = []
        this.frontOverlay = false
        this.enableClientSubscription = false
        this.lastDevisTimestamp = 0
        this.frontPersistence = true // true to remember client id and key in cookies
        if ( this.isFront() ) {
            if ( !this.frontPersistence ) this.getIdFromUrlAndCookie()
            else this.persistIdAndCookie()
        }
    }

    isFront() {
        return this.application == 'front'
    }

    isBack() {
        return this.application == 'back'
    }

    persistIdAndCookie() {
        const urlParams = new URLSearchParams(window.location.search);

        this.action = urlParams.get('action')
        this.affiliate = urlParams.get('affil') || ''

        this.id = ''
        this.type = 'moto'
        const idUrl = urlParams.get('id')
        if ( idUrl ) {
            if ( ! idUrl.match(/[^0-9a-z]/) ) {
                console.log("Got id from url ",idUrl)
                const type = idUrl.substring(0,4)
                if ( ['auto','moto'].includes( type ) ) {
                    this.type = type
                    this.id = idUrl.substring(4)
                } else {
                    this.type = 'moto'
                    this.id = idUrl
                }
            } else {
                console.log("Invalid id ",idUrl)
            }
        }

        if ( this.id ) {
            const idKey = urlParams.get('key')
            if ( idKey ) {
                document.cookie = this.id+"="+idKey+";path=/";
                urlParams.delete('key')
                window.location = '?'+urlParams.toString()+window.location.hash
                return
            } else {
                const matchk = document.cookie.match( '(?:^|;)\\s*'+this.id+'\\s*=\\s*([0-9a-f]+)' )
                const idCookiek = matchk ? matchk[1] : false
                if ( idCookiek ) {
                    this.idKey = idCookiek
                    document.cookie = this.id+"="+this.idKey+";path=/";
                }
            }
        }
    }
/*
    persistIdAndCookie() {
        const urlParams = new URLSearchParams(window.location.search);

        this.action = urlParams.get('action')
        this.affiliate = urlParams.get('affil') || ''

        this.idKey = ''
        const idKey = urlParams.get('key')
        if ( idKey ) {
            document.cookie = "clientKey="+idKey+";Max-Age=2592000;path=/";
            this.idKey = idKey
        }

        this.id = ''
        this.type = 'moto'
        const idUrl = urlParams.get('id')
        if ( idUrl ) {
            console.log("Setting cookie id ",idUrl)
            document.cookie = "clientId="+idUrl+";Max-Age=2592000;path=/";
            const type = idUrl.substring(0,4)
            if ( ['auto','moto'].includes( type ) ) {
                this.type = type
                this.id = idUrl.substring(4)
            } else {
                this.type = 'moto'
                this.id = idUrl
            }

            urlParams.delete('key')
            urlParams.delete('id')
            window.location = '?'+urlParams.toString()
            return
        }

        const match = document.cookie.match(/(?:^|;)\s*clientId\s*=\s*([0-9a-z]+)/)
        const idCookie = match ? match[1] : false

        const matchk = document.cookie.match(/(?:^|;)\s*clientKey\s*=\s*([0-9a-f]+)/)
        const idCookiek = matchk ? matchk[1] : false

        if ( idCookie && idCookiek ) {
            const type = idCookie.substring(0,4)
            if ( ['auto','moto'].includes( type ) ) {
                this.type = type
                this.id = idCookie.substring(4)
            } else {
                this.type = 'moto'
                this.id = idCookie
            }
            this.idKey = idCookiek
        }

    }
*/
    getIdFromUrlAndCookie() {

        const urlParams = new URLSearchParams(window.location.search);

        this.action = urlParams.get('action')

        this.affiliate = urlParams.get('affil') || ''

        this.idKey = ''
        const idKey = urlParams.get('key')
        if ( idKey ) {
            this.idKey = idKey
        }

        const idUrl = urlParams.get('id')
        if ( idUrl ) {
            const type = idUrl.substring(0,4)
            if ( ['auto','moto'].includes( type ) ) {
                this.type = type
                this.id = idUrl.substring(4)
            } else {
                this.type = 'moto'
                this.id = idUrl
            }

            return
        }

    }

    /** Registers component "view" for reception of devis that may have been updated in the backend
     * (view must provide a receiveDevis method)
     */
    registerDevisView(view) {
        this.devisViews.push(view)
    }

    unregisterDevisView(view) {
        this.devisViews = this.devisViews.filter( v => view!=v )
    }

    registerFrontOverlay( overlay ) {
        this.frontOverlay = overlay
    }

    unregisterFrontOverlay( overlay ) {
        if ( this.frontOverlay == overlay ) this.frontOverlay = false
    }

    registerEnableView(view) {
        this.enableViews.push(view)
    }

    unregisterEnableView(view) {
        this.enableViews = this.enableViews.filter( v => view!=v )
    }

    openFront( devis ) {
        if ( this.frontOverlay ) this.frontOverlay.open(devis)
    }

    closeFront() {
        if ( this.frontOverlay ) this.frontOverlay.open(false)
    }

    receiveDevis(devis,newDevis) {
        if ( this.isFront() &&( newDevis || !this.id )) {
            console.log(devis,newDevis)
            this.id = devis._id.$oid
            this.type = devis.type
            this.idKey = newDevis
            if ( !this.frontPersistence ) {
                window.location = '?id='+this.type+this.id+'&key='+this.idKey
                return
            } else {
                document.cookie = this.id+"="+this.idKey+";path=/";
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set('id',this.type+this.id)
                urlParams.delete('key')
                window.location = '?'+urlParams.toString()
                return
            }
        }
        const dataDevis = new DataDevis(devis)
        this.devisViews.forEach(view=>{
            view.receiveDevis(dataDevis)
        })
    }

    backendUrl(path) {
        return this.backend+path
    }

    affiliateUrl(_id,id) {
        if ( id ) _id += '-'+id
        return this.directFrontUrl+'?affil='+_id
    }

    qrUrl(login,template) {
        return this.backend+'/affichette.php?login='+encodeURIComponent(login)+'&template='+encodeURIComponent(template)
    }

    sollySubscribeUrl(id) {
        return this.backend+'/solly_subscribe.php?id='+id+'&token='+this.getToken()
    }

    downloadDevisUrl(id) {
        return this.backend+'/download_devis.php?id='+id+'&token='+this.getToken()
    }

    downloadDevisFma(id) {
        return this.backend+'/download_devis_fma.php?id='+id+'&token='+this.getToken()
    }

    downloadLogs(id,what) {
        return this.backend+'/view_logs.php?id='+id+'&what='+what+'&token='+this.getToken()
    }
    downloadTypeLogs(id,type) {
        return this.backend+'/view_logs.php?id='+id+'&type='+type+'&token='+this.getToken()
    }

    downloadDocument(id,name) {
        return this.backend+'/download_document.php?id='+id+'&name='+name+'&token='+this.getToken()
    }

    paymentUrl(id,branch) {
        return this.backend+'/../payment/form_pay.php?id='+id+'&branch='+branch+'&token='+this.getToken()
    }

    uploadFmaDoc(id,code) {
        return this.backend+'/upload_fma_doc.php?id='+id+'&code='+code+'&token='+this.getToken()
    }


    frontUrl(id) {
        return id ? this.backend+'/redir_front.php?id='+id+'&token='+this.getToken() : this.backend+'/redir_front.php?token='+this.getToken()
    }

    getToken() {
        switch ( this.application ) {
            case 'back':
                var match = document.cookie.match(/(?:^|;)\s*token\s*=\s*([0-9a-f]+)/)
                var ret = match ? match[1] : false
                return ret
            case 'front':
                return this.idKey
        }
      }

    getLogin() {
        var match = document.cookie.match(/(?:^|;)\s*login\s*=\s*([^;]+)/)
        var status = match ? match[1] : false
        if ( status != this.lastConnectedStatus ) {
            console.log('Change login',status)
            // catching a change in connection status in cookies
            this.lastConnectedStatus = status
            this.onConnectedStatus.forEach( f=>f(status) )
        }
        return status
    }

    isAdmin() {
        return this.lastConnectedStatus &&( adminUsers.includes( this.lastConnectedStatus ) )
    }

    isOperator() {
        return this.lastOperator
    }

    login(login,password) {
        var me = this
        $.ajax({
            url: this.url,
            type:'POST',
            data:{
                action:'connect',
                login:login,
                password:password,
                token:this.getToken()
            },
            dataType: 'json',
            success: function(res){
                if ( res.error ) {
                    me.showError(res.error)
                } else {
                    if ( res.token ) {
                        document.cookie = "token="+res.token+";Max-Age=2592000;path=/";
                        document.cookie = "login="+res.user+";Max-Age=2592000;path=/";
                        me.onAfterLogin.forEach( f=>f() )
                        me._onConnectedStatus( res.user )
                    }
                }
            },
            error: function() {
                me.showError('Internal error 1')
            }
        });
    }


    /** disconnect : clears token cookie
     */
     disconnect() {
        document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
        document.cookie = "login=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
        this.onAfterLogout.forEach( f=>f() )
        this._onConnectedStatus( false )
    }


    handlerOnAfterLogin(func) {
        this.onAfterLogin.push(func)
    }

    handlerOnAfterLogout(func) {
        this.onAfterLogout.push(func)
    }

    handlerOnConnectedStatus(func) {
        this.onConnectedStatus.push(func)
    }

    _onConnectedStatus(status) {
        const login = status ? status.login : false
        const operator = status ? !status.sponsor : false
        if ( !status ) {
            document.cookie = "login=; expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";                
        } else {
            document.cookie = "login="+login+";Max-Age=2592000;path=/";
        }
        if ( this.lastConnectedStatus != login ) {
            this.lastConnectedStatus = login
            this.lastOperator = operator
            this.onConnectedStatus.forEach( f=>f(login,operator) )
        }
    }

    makeUrl( what ) {
        let params = []
        what.token = this.getToken()

        for (let d in what)
            params.push(encodeURIComponent(d) + '=' + encodeURIComponent(what[d]))
        params = params.join('&');

        return this.url+'?'+$.param(what)         
    }

    post( what, onSuccess, onError ) {
        const me = this
        const data = {
            token:this.getToken(),
            ...what
        }
        if ( what.devis_timestamp ) {
            this.lastDevisTimestamp = what.devis_timestamp
        }
        $.ajax({
            url: this.url,
            type:'POST',
            data:data,
            dataType: 'json',
            success: function(res){
                if ( res.error ) {
                    if ( onError ) onError(res.error)
                    else me.showError(res.error)
                } else {
                    if ( res.token ) {
                        document.cookie = "token="+res.token+";Max-Age=2592000;path=/";
                    }

                    if ( res.hasOwnProperty( 'axa_status' ) ) {
                        me.axaStatus = res.axa_status
                        me.enableViews.forEach( view => view.setAxaLogout?.(
                            me.axaStatus
                        ) )
                    }

                    if ( res.hasOwnProperty( 'axa_alive') ) {
                        me.axaAlive = res.axa_alive
                        me.enableViews.forEach( view => view.setAxaAlive?.(
                            me.axaAlive
                        ))
                    }
                    if ( res.hasOwnProperty('user') ) { 
                        me._onConnectedStatus( res.user )
                    }

                    if ( res.hasOwnProperty('enable_client_subscription')) {
                        me.enableClientSubscription = res.enable_client_subscription
                        me.enableViews.forEach(view=>view.setEnableClientSubscription?.(me.enableClientSubscription))
                    }

                    if ( onSuccess ) onSuccess(res)

                    if ( res.hasOwnProperty('pre_close')) {
                        me.preClose = res.pre_close
                        me.enableViews.forEach(view=>view.setPreClose?.(me.preClose))
                    }

                    if ( res.devis &&( 
                        ( !res.devis_timestamp )
                        ||
                        ( res.devis_timestamp == me.lastDevisTimestamp )
                     )) {
                        me.receiveDevis( res.devis, res.new_devis ) 
                    }

                }
            },
            error: function(e) {
                console.log('Error : '+e.responseText)
            }
        });
    }

    getAxaVehicules( callback ) {
        if ( this.axaVehicules ) {
            $.ajax({
                url: this.backend+'/axa_vehicules.json',
                dataType: 'json',
                success: function(res) {
                    this.axaVehicules = res
                    callback( this.axaVehicules )
                }
            })
        } else {
            callback( this.axaVehicules )
        }
    }

    showError( message ) {
//        console.log(message)
        if ( message == 'unauthorized_key' ) {
            this.enableViews.forEach( view => view.notifyUnauthorized?.() )
        } else {
            window.alert(message)
        }
    }
    
}

export default new ApiConnector(process.env.REACT_APP_BACKEND,process.env.REACT_APP_SITE,process.env.REACT_APP_FRONT);

